import React from 'react'
import AuditTrailsTable from '../../common/AuditTrailsTable';
import { GetRegAuditFilters, GetStudentRegAuditTrailCancelToken } from '../../../services/RegistrationService';
import { useParams } from 'react-router-dom';

function AuditTrails() {
  const { id } = useParams();
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]
  return (
    <AuditTrailsTable
      apiFunction={GetStudentRegAuditTrailCancelToken}
      columnsToShow={columnsToShow}
      apiParams={id ? {parent_action_id: id} : {}}
      filterArrApi={GetRegAuditFilters}
      actionId={id}
      exportFileName={"Users Audit Trail"}
      staticResourceType="programme_re_registration"
    />
  )
}

export default AuditTrails;